import React from 'react';
import Icon from 'shared/components/icon';

interface Props {
  label: React.ReactNode;
  value?: string | number;
  // If provided, an Icon will be displayed with the given type.
  iconType?: string;
}

const MiniInfoCard = ({label, value, iconType}: Props) => {
  if (!value || !label) {
    return null;
  }

  return (
    <div className="college-profile-mini-info-card">
      {iconType && <Icon iconType={iconType} />}
      <div className="mini-info-card-label">{label}</div>
      <div className="mini-info-card-value">{value}</div>
    </div>
  );
};

export default MiniInfoCard;
